var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',[(_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('i',{staticClass:"fas fa-spinner fa-spin loading"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }